import fetch from 'cross-fetch'
import { notification } from 'antd';
import {IntlProvider, addLocaleData,FormattedMessage } from 'react-intl';
import { formatMessage } from '../localintl';

export const REQUEST_POSTS = 'REQUEST_POSTS';
export const RECEIVE_POSTS = 'RECEIVE_POSTS';
export const INVALIDATE_SUBREDDIT = 'INVALIDATE_SUBREDDIT';
const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};

const checkStatus = response => {
    console.log(formatMessage,'formatMessage')
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const errortext = codeMessage[response.status] || response.statusText;
    // notification.destroy();
    notification.error({
        message: `${formatMessage({id:'common.message.request.fail'})}  ${response.status}: ${response.url}`,
        description: errortext,
    });
    const error = new Error(errortext);
    error.name = response.status;
    error.response = response;
    throw error;
};

export function invalidateSubreddit(subreddit) {
    return {
        type: INVALIDATE_SUBREDDIT,
        subreddit
    }
}

function requestPosts(subreddit) {
    return {
        type: REQUEST_POSTS,
        subreddit
    }
}

function receivePosts(subreddit, json) {
    let data={};
    if(json.errorCode==200){
        data=json.data;

    }
    return {
        type: RECEIVE_POSTS,
        subreddit,
        posts: data,
    }
}

function fetchPosts(subreddit,callback) {
    subreddit.params=subreddit.params||{};
    subreddit.options=subreddit.options||{
        method: 'post',
        headers: {
            'Accept-Language':subreddit.locale||'zh-CN',
            'Content-Type': 'application/json',
            accessToken:localStorage.getItem('accessToken')?localStorage.getItem('accessToken'):'',
        }
    }


    return dispatch => {
        dispatch(requestPosts(subreddit));
        debugger
        return fetch(subreddit.url,{...subreddit.options, body:  subreddit.params instanceof FormData? subreddit.params:JSON.stringify(subreddit.params)}).then(checkStatus)
            .then(response => response.json())
            .then(json => {
                console.log(json,'currrr')
                if(json.errorCode != 200){
                    throw 'error';
                }
                dispatch(receivePosts(subreddit, json))}).then((json)=>{
                if(callback&&typeof callback=="function"){
                    callback()
                }
            }).catch(e=>{
                console.log(e,'e')
                // window.location.reload()
            })


    }
}

function shouldFetchPosts(state, subreddit) {
    const posts = state.posts[subreddit.name]
    if ((!posts.isFetching)&&(!posts.didInvalidate)) {
        return true
    } else if (posts.isFetching) {
        return false
    } else {
        return posts.didInvalidate
    }
}

export function fetchPostsIfNeeded(subreddit,callback) {
    return (dispatch, getState) => {
        if (shouldFetchPosts(getState(), subreddit)) {
            return dispatch(fetchPosts(subreddit,callback))
        }
    }
}